__turbopack_context__.v({
  "save-card-field-label": "EmailSignatureEditorSaveContactSection-module-scss-module__KqP-8a__save-card-field-label",
  "save-card-field-multi-steps": "EmailSignatureEditorSaveContactSection-module-scss-module__KqP-8a__save-card-field-multi-steps",
  "save-card-field-option": "EmailSignatureEditorSaveContactSection-module-scss-module__KqP-8a__save-card-field-option",
  "save-card-form-selector": "EmailSignatureEditorSaveContactSection-module-scss-module__KqP-8a__save-card-form-selector",
  "save-card-group-form-selector": "EmailSignatureEditorSaveContactSection-module-scss-module__KqP-8a__save-card-group-form-selector",
});
